
export enum PcmsDraftStatus {
    NotOpen = 'PCPS_NOT_OPEN',
    Open = 'PCPS_OPEN',
    Closed = 'PCPS_CLOSED',
    Accepted = 'PCPS_ACCEPTED',
    Withdrawn = 'PCPS_WITHDRAWN',
}